import { snapToFrame } from './util/time.js';
import { quellZeit, rampeVon } from './rampe.js';
/**
 * Ein Bild anhalten und stehen lassen (S8).
 *
 * Sascha: „Ein Bild anhalten und stehen lassen.“ Das ist zweierlei: der
 * Server holt das Bild aus der Datei, und hier wird entschieden, **wo** es
 * auf der Zeitleiste landet und was dafür ausweichen muss.
 *
 * Die Regel ist die, die man von Hand nachbauen würde: an der Stelle trennen,
 * das Standbild dazwischenschieben, alles dahinter um seine Länge nach hinten.
 * Nichts wird überschrieben, und die Reihenfolge bleibt.
 */
/**
 * Wie lang ein Standbild steht, wenn niemand etwas anderes sagt.
 *
 * Vier Sekunden wie bei einem eingefügten Bild wären ein Starren; zwei
 * Sekunden sind ein Blick. Wer länger will, zieht am Rand -- das ist ein
 * Griff, kein Dialog.
 */
export const STANDBILD_DAUER = 2;
/**
 * Wo in der Quelldatei man ist, wenn im Clip `lokal` Sekunden vergangen sind.
 * Mit Rampe ist das keine Multiplikation mehr, sondern die Fläche unter dem
 * Tempo -- dieselbe Rechnung, die der Export benutzt (S6).
 */
export function quellStelle(clip, lokal) {
    return clip.sourceIn + quellZeit(lokal, clip.duration, rampeVon(clip));
}
/**
 * Der Plan für ein Standbild aus `clipId` an der Stelle `at` (Zeitleiste).
 *
 * `clips` sind die Clips **einer** Spur: nur dort muss etwas ausweichen.
 * Eine andere Spur rutscht nicht mit -- sonst verschöbe ein Standbild im Bild
 * den Ton darunter, und niemand hätte darum gebeten.
 */
export function standbildPlan(clips, clipId, at, fps, dauer = STANDBILD_DAUER) {
    const clip = clips.find((c) => c.id === clipId);
    if (!clip || dauer <= 0)
        return null;
    const ende = clip.start + clip.duration;
    const roh = snapToFrame(Math.min(ende, Math.max(clip.start, at)), fps);
    const vorn = roh <= clip.start + 1 / fps;
    const hinten = roh >= ende - 1 / fps;
    const start = vorn ? clip.start : hinten ? ende : roh;
    // Das letzte Bild des Clips liegt ein Bild vor seinem Ende -- danach ist
    // schon der nächste dran. Wer am Ende einfriert, will dieses letzte Bild.
    const lokal = Math.max(0, Math.min(clip.duration - 1 / fps, start - clip.start));
    // Vorn weicht der Clip selbst aus, sonst nur, was hinter ihm anfängt. Der
    // zweite Teil beim Trennen steht nicht in der Liste: den gibt es noch nicht.
    const grenze = vorn ? clip.start : clip.start + 1e-9;
    return {
        quelle: quellStelle(clip, lokal),
        start,
        dauer,
        teilen: !vorn && !hinten,
        nachruecker: clips
            .filter((c) => c.start >= grenze)
            .sort((a, b) => a.start - b.start)
            .map((c) => ({ clipId: c.id, start: c.start + dauer })),
    };
}
//# sourceMappingURL=standbild.js.map